import React from "react";
import { TENANTS } from "../../consts/tables";
import TenantInfo from "./TenantInfo";
import CRUD from "../CRUD/CRUD";
import { getCurrentAccess } from "../../access";
import { editsEverySummitRecord } from "../../access-levels";
import { browserHistory } from "react-router";
import { getData, manageData } from "../../requests/CRUD";

export default class CRUDTenant extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      original: null,
      isBusy: null,
      error: null,
      success: null,
      errorTabs: [],
      currentTab: 0,
      viewMode: this.props.edit || false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.saveData = this.saveData.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.fetch(nextProps.params.id);
    }
  }

  componentDidMount() {
    this.fetch(this.props.params.id);
  }

  fetch(id) {
    this.setState({
      data: null,
      error: null,
      success: null,
    });

    if (id === undefined) {
      this.setState({
        data: {},
      });
      return;
    }

    getData({
      tableCode: TENANTS,
      options: {
        filter: [
          {
            text: id,
            code: "ARCIMEDES_ROW_ID",
            type: "exact",
          },
        ],
      },
    }).then((res) => {
      if (res && res.success && Array.isArray(res.data) && res.data.length) {
        this.setState({
          data: res.data[0],
          original: { ...res.data[0] },
          error: null,
        });
      } else {
        this.setState({
          data: false,
          error: res.message ? res.message : "Unidentified Error",
        });
      }
    });
  }

  handleSubmit(e) {
    e.preventDefault();

    if (this.state.viewMode) this.setState({ viewMode: false });

    if (
      this.state.isBusy ||
      this.state.data.NAME === "" ||
      this.state.viewMode === true
    )
      return;

    this.setState({ viewMode: true }, () => this.saveData());
  }

  handleChangeInput(key, value) {
    this.setState({
      data: Object.assign(this.state.data, {
        [key]: value,
      }),
    });
  }

  saveData() {
    if (this.state.isBusy) return;

    this.setState({
      isBusy: true,
      error: null,
      success: null,
    });

    return manageData({ tableCode: TENANTS, data: [this.state.data] }).then(
      (res) => {
        if (res && res.success) {
          this.setState(
            {
              isBusy: false,
              success: "Saved",
            },
            () => {
              if (!this.props.edit) {
                browserHistory.push({
                  pathname: `/tenant/${res.data[0].ARCIMEDES_ROW_ID}`,
                });
              }
            }
          );
          window.scrollTo(0, 0);
        } else {
          this.setState({
            isBusy: null,
            error: res && res.message ? res.message : "Unspecified error",
          });
        }
      }
    );
  }

  render() {
    const data = this.state.data;
    const { edit } = this.props;

    return (
      <CRUD
        tabsData={[
          {
            name: "TENANT",
            renderedComponent: (
              <TenantInfo
                data={data}
                handleChangeInput={this.handleChangeInput}
                viewMode={this.state.viewMode}
                deleted={data && data.DELETED === "1"}
              />
            ),
          },
        ]}
        backLink={`${arc.path.base}tenants`}
        edit={edit}
        state={this.state}
        setState={this.setState.bind(this)}
        handleSubmit={this.handleSubmit}
        saveData={this.saveData}
        type="tenant"
        backName="TENANTS"
        title={data && `${data.NAME}`}
        /* Edit and Delete for whoever edits every SUMMIT record (the old admin rule). */
        forceActions={editsEverySummitRecord(getCurrentAccess())}
      />
    );
  }
}
